export const APP_AERO_URL = 'https://aerospace.products.constellium.com'
export const APP_AUTO_URL = 'https://automotive.products.constellium.com'